import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { optimizedImage } from "@/lib/image-url";
import { cn } from "@/lib/utils";

/**
 * One place that decides how a person is pictured across Xamseen. If the person
 * has uploaded a photo it is always used; the neutral initial only appears when
 * their profile genuinely has no image.
 */
export function UserAvatar({
  name,
  username,
  avatarUrl,
  className,
  size = 40,
}: {
  name?: string | null;
  username?: string | null;
  avatarUrl?: string | null;
  className?: string;
  /** Rendered pixel edge — used to request a right-sized image. */
  size?: number;
}) {
  const label = (name || username || "").trim();
  const initial = (label[0] || "?").toUpperCase();
  return (
    <Avatar className={cn("bg-muted", className)}>
      {avatarUrl ? (
        <AvatarImage
          src={optimizedImage(avatarUrl, size * 2, 70)}
          alt={label ? `${label}'s profile photo` : "Profile photo"}
          loading="lazy"
          decoding="async"
        />
      ) : null}
      <AvatarFallback className="bg-muted font-medium text-muted-foreground">
        {initial}
      </AvatarFallback>
    </Avatar>
  );
}
